(function () {
    document.addEventListener('DOMContentLoaded', function () {
        // Get all play buttons on product cards
        const productCardPlayButtons = document.querySelectorAll('.product-card-play-btn');

        productCardPlayButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const modalId = this.getAttribute('data-modal-id');
                const modal = document.getElementById(modalId);

                if (modal) {
                    modal.classList.add('active');
                    document.body.style.overflow = 'hidden';

                    const video = modal.querySelector('.video-modal-player');
                    if (video) {
                        video.play().catch(function (err) {
                            console.log('Video play error:', err);
                        });
                    }
                }
            });
        });

        // Get all fullscreen buttons
        const fullscreenButtons = document.querySelectorAll('.video-fullscreen-btn');

        fullscreenButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                const modalId = this.getAttribute('data-modal-id');
                const modal = document.getElementById(modalId);

                if (modal) {
                    // Show modal
                    modal.classList.add('active');
                    document.body.style.overflow = 'hidden';

                    // Play video and detect aspect ratio
                    const video = modal.querySelector('.video-modal-player');
                    if (video) {
                        // Default to landscape initially
                        if (!modal.classList.contains('portrait') && !modal.classList.contains('landscape')) {
                            modal.classList.add('landscape');
                        }

                        // Track detection attempts
                        let detectionAttempts = 0;
                        const maxAttempts = 10;

                        // Get video index for fallback
                        const videoIndex = modal.getAttribute('data-video-index');

                        // Detect video orientation when metadata is loaded
                        function detectVideoOrientation() {
                            detectionAttempts++;

                            // Try multiple times if dimensions aren't ready
                            if (video.videoWidth > 0 && video.videoHeight > 0) {
                                const aspectRatio = video.videoWidth / video.videoHeight;
                                // Remove existing orientation classes
                                modal.classList.remove('portrait', 'landscape', 'square');

                                if (aspectRatio > 1.1) {
                                    // Landscape (width > height)
                                    modal.classList.add('landscape');
                                } else if (aspectRatio < 0.9) {
                                    // Portrait (height > width)
                                    modal.classList.add('portrait');
                                } else {
                                    // Square or near square - default to landscape styling
                                    modal.classList.add('landscape');
                                }

                                // Force reflow to ensure CSS is applied
                                void modal.offsetHeight;
                            } else if (detectionAttempts < maxAttempts) {
                                // If dimensions not available, try again after a short delay
                                setTimeout(detectVideoOrientation, 150);
                            } else {
                                // Fallback: Use video index if detection fails
                                // First video = landscape, Second video = portrait (adjust as needed)
                                modal.classList.remove('portrait', 'landscape', 'square');
                                if (videoIndex === '1') {
                                    modal.classList.add('landscape');
                                } else if (videoIndex === '2') {
                                    modal.classList.add('portrait');
                                } else {
                                    modal.classList.add('landscape'); // Default
                                }
                                void modal.offsetHeight;
                            }
                        }

                        // Force video to load metadata
                        video.load();

                        // Try to detect immediately if dimensions are available
                        if (video.readyState >= 1 && video.videoWidth > 0 && video.videoHeight > 0) {
                            detectVideoOrientation();
                        } else {
                            // Wait for metadata to load - try multiple events
                            video.addEventListener(
                                'loadedmetadata',
                                function () {
                                    detectVideoOrientation();
                                },
                                { once: true }
                            );

                            video.addEventListener(
                                'loadeddata',
                                function () {
                                    detectVideoOrientation();
                                },
                                { once: true }
                            );

                            video.addEventListener(
                                'canplay',
                                function () {
                                    detectVideoOrientation();
                                },
                                { once: true }
                            );

                            // Fallback: try after video starts playing
                            video.addEventListener(
                                'playing',
                                function () {
                                    setTimeout(detectVideoOrientation, 300);
                                },
                                { once: true }
                            );

                            // Additional fallback after a delay
                            setTimeout(function () {
                                if (video.videoWidth === 0 || video.videoHeight === 0) {
                                    detectVideoOrientation();
                                }
                            }, 500);
                        }

                        video.play().catch(function (err) {
                            // Still try to detect orientation even if play fails
                            setTimeout(detectVideoOrientation, 500);
                        });
                    }
                }
            });
        });

        // Function to close modal and reset orientation classes
        function closeModal(modal) {
            if (modal) {
                const video = modal.querySelector('.video-modal-player');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
                // Remove orientation classes for clean state
                modal.classList.remove('active', 'portrait', 'landscape', 'square');
                document.body.style.overflow = '';
            }
        }

        // Close modal functionality
        const closeButtons = document.querySelectorAll('.video-modal-close');
        closeButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                const modal = this.closest('.video-modal');
                closeModal(modal);
            });
        });

        // Close modal when clicking outside the video
        const modals = document.querySelectorAll('.video-modal');
        modals.forEach(function (modal) {
            modal.addEventListener('click', function (e) {
                if (e.target === modal) {
                    closeModal(modal);
                }
            });
        });

        // Close modal with Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                modals.forEach(function (modal) {
                    if (modal.classList.contains('active')) {
                        closeModal(modal);
                    }
                });
            }
        });
    });
})();